const ThreeUsersIcon = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.98154 13.5786C5.82221 13.5786 3.97754 13.252 3.97754 11.944C3.97754 10.636 5.81021 9.49731 7.98154 9.49731C10.1409 9.49731 11.9855 10.6253 11.9855 11.9326C11.9855 13.24 10.1529 13.5786 7.98154 13.5786Z"
        stroke="#5F5F5F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.98172 7.63242C9.39905 7.63242 10.5484 6.48376 10.5484 5.06642C10.5484 3.64909 9.39905 2.49976 7.98172 2.49976C6.56438 2.49976 5.41505 3.64909 5.41505 5.06642C5.41105 6.47842 6.55105 7.62776 7.96372 7.63242H7.98172Z"
        stroke="#5F5F5F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.2415 6.92777C13.0662 6.70711 13.6742 5.9551 13.6742 5.05977C13.6742 4.12577 13.0122 3.34577 12.1309 3.16577"
        stroke="#5F5F5F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6287 9.02954C13.798 9.02954 14.7967 9.82221 14.7967 10.5302C14.7967 10.9469 14.452 11.4009 13.9293 11.5235"
        stroke="#5F5F5F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.7224 6.92777C2.89706 6.70711 2.28906 5.9551 2.28906 5.05977C2.28906 4.12577 2.95173 3.34577 3.8324 3.16577"
        stroke="#5F5F5F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.3345 9.02954C2.16517 9.02954 1.1665 9.82221 1.1665 10.5302C1.1665 10.9469 1.51117 11.4009 2.0345 11.5235"
        stroke="#5F5F5F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

ThreeUsersIcon.Primary = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7723 5.48865C10.7723 7.0551 9.5235 8.31115 7.9661 8.31115C6.4087 8.31115 5.15991 7.0551 5.15991 5.48865C5.15991 3.92159 6.4087 2.66675 7.9661 2.66675C9.5235 2.66675 10.7723 3.92159 10.7723 5.48865ZM7.9661 13.3334C5.67865 13.3334 3.72547 12.9708 3.72547 11.5202C3.72547 10.069 5.66611 9.69316 7.9661 9.69316C10.2536 9.69316 12.2067 10.0558 12.2067 11.507C12.2067 12.9576 10.2661 13.3334 7.9661 13.3334ZM11.9715 5.53956C11.9715 6.3381 11.7333 7.082 11.3154 7.70042C11.2725 7.76406 11.3107 7.84992 11.3865 7.86313C11.4909 7.88114 11.599 7.89135 11.7088 7.89435C12.8042 7.92317 13.7874 7.21409 14.059 6.14657C14.4613 4.5609 13.28 3.13735 11.7757 3.13735C11.6121 3.13735 11.4557 3.15476 11.3035 3.18598C11.2826 3.19078 11.2605 3.20039 11.2486 3.219C11.2343 3.24182 11.245 3.27244 11.2593 3.29225C11.7112 3.92928 11.9715 4.7062 11.9715 5.53956ZM13.7856 9.00846C14.5216 9.15316 15.0057 9.44856 15.2063 9.87785C15.3758 10.2303 15.3758 10.6392 15.2063 10.991C14.8994 11.6568 13.9103 11.8706 13.5259 11.9258C13.4465 11.9378 13.3826 11.8688 13.391 11.7889C13.5874 9.94389 12.0252 9.0691 11.6211 8.86797C11.6038 8.85896 11.6002 8.84515 11.602 8.83674C11.6032 8.83074 11.6103 8.82113 11.6235 8.81933C12.498 8.80312 13.4381 8.9232 13.7856 9.00846ZM4.29149 7.89429C4.40132 7.89129 4.50877 7.88168 4.61383 7.86307C4.68964 7.84986 4.72785 7.764 4.68487 7.70036C4.26701 7.08194 4.02884 6.33804 4.02884 5.5395C4.02884 4.70614 4.2891 3.92922 4.74098 3.29219C4.75531 3.27238 4.76545 3.24176 4.75172 3.21894C4.73979 3.20093 4.7171 3.19072 4.69681 3.18592C4.54399 3.1547 4.38759 3.13728 4.22403 3.13728C2.71976 3.13728 1.53842 4.56084 1.94135 6.14651C2.21296 7.21403 3.19611 7.92311 4.29149 7.89429ZM4.39804 8.83638C4.39983 8.84539 4.39625 8.8586 4.37954 8.86821C3.97481 9.06934 2.41263 9.94413 2.60903 11.7886C2.61738 11.869 2.55411 11.9375 2.47472 11.9261C2.09029 11.8708 1.10117 11.6571 0.794343 10.9912C0.624216 10.6388 0.624216 10.2305 0.794343 9.87809C0.994913 9.4488 1.47843 9.1534 2.21445 9.0081C2.56246 8.92344 3.50204 8.80336 4.37715 8.81957C4.39028 8.82137 4.39685 8.83098 4.39804 8.83638Z"
        fill="#6014C4"
      />
    </svg>
  );
};

export default ThreeUsersIcon;
